import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBreadcrumbLabel } from '@/contexts/BreadcrumbContext';
import { DocumentView } from '@/features/documents/DocumentView';

export function LibraryDocumentPage() {
  const { id } = useParams<{ id: string }>();
  const { setBreadcrumbLabel } = useBreadcrumbLabel();

  useEffect(() => {
    return () => setBreadcrumbLabel(null);
  }, [setBreadcrumbLabel]);

  if (!id) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <p className="text-muted-foreground">Missing document ID.</p>
      </div>
    );
  }

  return (
    <DocumentView
      documentId={id}
      onTitleLoaded={(title) => setBreadcrumbLabel(title)}
    />
  );
}
